import React, { useEffect } from "react";
import { Navigate } from "react-router";

import { useAppSelector, useAppDispatch } from "./lib/hooks";
import { updateChannel, updateSessionToken, updateSetNotificationsVisible } from './lib/slices/imparcialApp';
import { updateConfig } from "./lib/slices/appConfig";
import Api from './lib/Api';

interface ProtectedProps {
    children: React.ReactElement
}

export default function Protected({children}: ProtectedProps) {

    // get the auth token and other stuff
    // check if authed
    const sessionToken = useAppSelector((state) => state.imparcial.sessionToken);
    const notificationsVisible = useAppSelector((state) =>  state.imparcial.setNotificationsVisible);

    const dispatch = useAppDispatch();

    useEffect(() => {
        (async () => {
            if(sessionToken && sessionToken != "") {
                const refreshResponse = await Api.refreshToken();
                if(!refreshResponse.Error) {
                    const response = refreshResponse.Data;
                    if(response) {
                        dispatch(updateSessionToken(response.SessionToken));
                        dispatch(updateChannel(response.Channel));
                    }
                }
            }
        })();
    });

    useEffect(() => {
        (async () => {
            if(sessionToken && sessionToken != "") {
                const configResult = await Api.getConfig();
                if(!configResult.Error) {
                    const config = configResult.Data;
                    if(config) {
                        dispatch(updateConfig(config));
                    }
                }
            }
        })();
    }, [sessionToken])

    function toggleNotificationPanel() {
        const nav = document.getElementById("notif_container");
        if(nav) {
            if(notificationsVisible) {
                nav.classList.add("hide-notification-container");
                nav.style.opacity = "0";
                nav.style.visibility = "hidden";
                nav.classList.remove("hide-notification-container");
                nav.classList.add("show-notification-container");
                dispatch(updateSetNotificationsVisible(!notificationsVisible));
            }
        }
    }

    if(sessionToken == "") {
        // not authed, redirect home
        // navigate("/iniciar-sesion")
        return <Navigate to="/iniciar-sesion" replace />
    }

    return (
        <div onClick={() => toggleNotificationPanel()}>
            {children}
        </div>
    );

}